<template>
	<div>
		<label :for="setting" class=""><input type="checkbox" :name="setting" :id="setting" v-model="status" v-on:click="toggleSetting"> <i v-if="loading" class="fa fa-spinner fa-spin fa-fw"></i><i v-else class="fa fa-blank fa-fw"></i><strong>{{label}}</strong> </label>
	</div>
</template>


<script>
'use strict';


	export default {
		name: 'Checkbox',
		data() {
			return {
				setting: '',
				label: '',
				status: '',
				loading: true
			}
		},

		methods: {

			async getSetting() {

				try {


					this.loading = true;
					const url = Routing.generate('ApiBundle_get_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const setting = await fetch(request);
					const settingJson = await setting.json();
					this.status = parseInt(settingJson.data);
					this.loading = false;
				} catch(error) {
					console.error(error);
				}

			},

			async toggleSetting() {

				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_toggle_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const status = await fetch(request);
					const statusJson = await status.json();
					this.status = parseInt(statusJson.data);
					this.loading = false;
				} catch(error) {
					console.error(error);
				}


			}

		
		},

		computed: {
			booleanStatus() {
				if(this.status == 1) {
					return true;
				} else {
					return false;
				}
			}
		
		},

		components: {

		},

		beforeMount() {
			this.setting = this.$root.$el.dataset.settingName;
			this.label = this.$root.$el.dataset.settingLabel;
			this.correspondingSetting = this.$root.$el.dataset.correspondingSetting;
		},

		mounted() {
			this.getSetting();
		},
		created() {

		}

	}	
</script>



<style>

[v-cloak] {
	display: none;
}

	
</style>